import GetComplianceActionsSchema, {
  GetComplianceActionsSchemaContract,
} from 'schemas/GetComplianceActionsSchema';
import InitiateComplianceActionSchema, {
  InitiateComplianceActionSchemaContract,
} from 'schemas/InitiateComplianceActionSchema';
import SubmitComplianceActionOtpSchema, {
  SubmitComplianceActionOtpSchemaContract,
} from 'schemas/SubmitComplianceActionOtpSchema';
import { getApi, postApi } from 'utils/Api';

type InitiateComplianceActionApiRequestData = {
  type: string;
  payroll_month: string;
  amount: number;
};

type SubmitComplianceActionOtpApiRequestData = {
  otp: string;
  compliance_id: string | number;
  payroll_month: string;
};

type MarkAsPaidComplianceActionApiRequestData = {
  type: string;
  payroll_month: string;
};

const complianceActions = {
  getComplianceActions: (payrollMonth: string) => {
    return getApi<GetComplianceActionsSchemaContract>({
      url: `/compliance/actions?payroll_month=${payrollMonth}`,
      responseSchema: GetComplianceActionsSchema,
    });
  },

  initiateComplianceAction: (params: { payrollMonth: string; type: string; amount: number }) => {
    return postApi<InitiateComplianceActionSchemaContract, InitiateComplianceActionApiRequestData>({
      url: '/compliance/initiate',
      responseSchema: InitiateComplianceActionSchema,
      requestData: {
        type: params.type,
        payroll_month: params.payrollMonth,
        amount: params.amount,
      },
    });
  },

  submitComplianceActionOtp: (params: {
    payrollMonth: string;
    otp: string;
    complianceId: string | number;
  }) => {
    return postApi<
      SubmitComplianceActionOtpSchemaContract,
      SubmitComplianceActionOtpApiRequestData
    >({
      url: '/compliance/otp/submit',
      responseSchema: SubmitComplianceActionOtpSchema,
      requestData: {
        otp: params.otp,
        compliance_id: params.complianceId,
        payroll_month: params.payrollMonth,
      },
    });
  },

  markAsPaidComplianceAction: (params: { payrollMonth: string; type: string }) => {
    return postApi<
      SubmitComplianceActionOtpSchemaContract,
      MarkAsPaidComplianceActionApiRequestData
    >({
      url: '/compliance/mark-paid',
      responseSchema: SubmitComplianceActionOtpSchema,
      requestData: {
        type: params.type,
        payroll_month: params.payrollMonth,
      },
    });
  },
};

export default complianceActions;
